export const onlyNumber = (e, isDec = true) => {
    const blockedKeys = ['e', 'E', '+', '-'];
    if (!isDec) blockedKeys.push('.');
    if (blockedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

// animal_type enum -> the label the register and every screen actually shows.
// Kept here because Analytics, Bonus and CustomRateChart each declared their own copy.
export const TYPE_LABEL = { cow: "गाय", buffalo: "म्हैस" };

// YYYY-MM-DD in IST. Never use toISOString() for this: it is UTC, so between 00:00
// and 05:30 IST it returns the PREVIOUS day — which silently dated saved records and
// filter defaults a day early.
export const toISODate = (d = new Date()) =>
  d.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
